import { render, staticRenderFns } from "./PaymentLinkOverview.vue?vue&type=template&id=b4992394&scoped=true"
import script from "./PaymentLinkOverview.vue?vue&type=script&lang=js"
export * from "./PaymentLinkOverview.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkOverview.vue?vue&type=style&index=0&id=b4992394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4992394",
  null
  
)

export default component.exports